import { tree2flatHelp } from '@/utils/flat2tree'
const IndexBaseMixin = {
  data() {
    return {
      shopOptions: [],
      shopOptionsFlat: {}
    }
  },
  methods: {
    // 查询门店组织
    formateShopList(data) {
      if (!data) return
      this.shopOptions = data
      this.shopOptionsFlat = tree2flatHelp(data)
    },
    // 保存时获取门店code集合
    getSelectedShopId(shopCodes) {
      const { shopOptionsFlat } = this
      const ids = []
      const deepFilter = (data) => {
        data.forEach((code) => {
          const curShop = shopOptionsFlat[code]
          if (!curShop) return
          if (!curShop.children) {
            // push 门店id
            ids.push(curShop.code)
          }
          if (curShop.children && curShop.children.length > 0) {
            const codeMap = curShop.children.map((item) => item.id)
            deepFilter(codeMap)
          }
        })
      }
      deepFilter(shopCodes)
      return ids
    }
  }
}
export default IndexBaseMixin
